<div class="addendum-dialog">
  <h1 mat-dialog-title>Addendum</h1>
</div>
<div mat-dialog-content class="addendum-content">
  <div>Proceeding with an addendum will enable edits to only your current vendor list and reset the initial RFQ deadline emailed to vendors.</div>
  <div class="are-you-sure">Are you sure you wish to continue?</div>
  <div class="addendum-info"><span class="label">Initial RFQ deadline:</span><span>12-Oct-23, 23.59pm</span></div>
</div>
<div class="btn-block" mat-dialog-actions>
    <app-button class="padBtn" name="Cancel" (click)="close()"></app-button>
    <app-button class="padBtn actionBtn" type="flat-button" name="Continue" (click)="onContinue()"></app-button>
</div>